/*
 * (c) Copyright, 2026, Medidata Solutions Worldwide, Inc. All rights reserved.
 *
 * EOS Overview Page - Entry point
 *
 * Migrated from: lego/page/eos/overview/Page.jsx
 *
 * In the new React app, ServiceProvider / PageFrame are handled at the app level,
 * so this component simply renders EosOverview with the appropriate props.
 */

import EosOverview from './EosOverview'

interface EosOverviewPageProps {
  isLegacy?: boolean
}

const EosOverviewPage: React.FC<EosOverviewPageProps> = ({ isLegacy = false }) => {
  return <EosOverview key={isLegacy ? 'legacy' : 'current'} isLegacy={isLegacy} />
}

export default EosOverviewPage
